import { escapeHtml } from '../escape.js';
import { editAttr, itemCollection, itemStr, labeledIntro, list, sectionOpen, str } from './helpers.js';
import type { PatternSectionT } from '../../schema/index.js';

/** hours — primary variant `list`: heading + day/hours rows. */
export function renderHours(section: PatternSectionT): string {
  const heading = str(section.fields, 'heading');
  const rows = list(section.fields, 'rows')
    .map((item, index) => {
      const day = itemStr(item, 'day');
      const hours = itemStr(item, 'hours');
      if (!day) return '';
      const rowPath = `/rows/${index}`;
      return [
        `    <div class="ve-hours__row"${editAttr(section, rowPath)}>`,
        `      <span class="ve-hours__day">${escapeHtml(day)}</span>`,
        `      <span class="ve-hours__time">${escapeHtml(hours)}</span>`,
        '    </div>',
      ].join('\n');
    })
    .filter(Boolean)
    .join('\n');

  const parts: string[] = [
    sectionOpen(section),
    ...labeledIntro(section, 'hours', heading),
    itemCollection(section, 'div', 've-hours__rows', '/rows', rows),
    '</section>',
  ];
  return parts.join('\n');
}
